<template>
  <b-modal ref="lista_de_sepacao" hide-footer size="xl">
    <template #modal-title> Lista dos itens para separação </template>
    <div class="col-lg-12" style="overflow-y: scroll; height: 55vh">
      <b-row>
        <b-col>
          <b-form-group label="Tipo de listagem">
            <b-form-radio-group v-model="selected_tipo_listagem" :options="options_tipo_listagem"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row v-if="spinner_i">
        <b-col>
          <div class="text-center">
            <b-spinner variant="success" label="Spinning"></b-spinner><br />
          </div>
        </b-col>
      </b-row>
      <div v-else id="table_items_pedido">
        <b-row v-show="selected_tipo_listagem === 'por_pedido'">
          <div class="table-responsive">
            <template v-if="produtos_por_items.length === 0">
              Você não selecionou nenhum registro
            </template>
            <template v-else v-for="oneProductPerOrder in produtos">
              <div class="mt-3 mb-5 table-responsive per-order-table">
                <table class="table table-striped table-sm table-condensed">
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <small class="text-muted">Comprador</small><br>
                        {{ oneProductPerOrder.payer_name || '&nbsp;' }}
                        <hr class="my-2"><br class="d-none d-print-block">
                        <small class="text-muted">Recebedor</small><br>
                        {{ oneProductPerOrder.receiver_name || '&nbsp;' }}
                      </td>
                      <td>
                        <small class="text-muted">Pedido Plugg.to</small><br>
                        {{ oneProductPerOrder.id || '&nbsp;' }}
                        <hr class="my-2"><br class="d-none d-print-block">
                        <small class="text-muted">Pedido Canal</small><br>
                        {{ oneProductPerOrder.original_id || '&nbsp;' }}
                      </td>
                      <td>
                        <small class="text-muted">Canal</small><br>
                        {{ oneProductPerOrder.channel || '&nbsp;'}}
                        <hr class="my-2"><br class="d-none d-print-block">
                        <small class="text-muted">Conta</small><br>
                        {{ oneProductPerOrder.channel_account || '&nbsp;'}}
                      </td>
                      <td colspan="2">
                        <small class="text-muted">Nota(s) Fiscal(is)</small><br>
                        {{ oneProductPerOrder.nfes || '&nbsp;' }}
                        <hr class="my-2"><br class="d-none d-print-block">

                      </td>
                    </tr>
                    <template v-for="oneItem in oneProductPerOrder.items">
                        <tr>
                          <td tyle="width: 60px; vertical-align:middle;"><b-img :src="oneItem.photo_url" style="width: 50px; min-width: 50px"/></td>
                          <td>
                            <small class="text-muted">Nome</small><br>
                            {{ oneItem.name }}
                          </td>
                          <td>
                            <small class="text-muted">sku(s)</small><br>
                            {{ skuVariation(oneItem) }}
                          </td>
                          <td>
                            <small class="text-muted">Quantidade</small><br>
                            {{ oneItem.quantity }}
                          </td>
                          <td>
                            <small class="text-muted">Preço</small><br>
                            {{ formatNumber(oneItem.price) }}
                          </td>
                          <td>
                            <small class="text-muted">Total</small><br>
                            {{ formatNumber(oneItem.total) }}
                          </td>
                        </tr>
                        <tr class="d-none d-print-block">
                          <td colspan="6"></td>
                        </tr>
                        <tr class="d-none d-print-block">
                          <td colspan="6" style="border-bottom: 2px solid #000;"></td>
                        </tr>
                      </template>
                  </tbody>
                </table>
            </div>
            </template>
          </div>
        </b-row>

        <b-row v-show="selected_tipo_listagem === 'por_item'">
          <b-col>
            <div class="table-responsive">
              <table class="table table-striped table-sm table-condensed">
                <template v-if="produtos_por_items.length === 0">
                  <tbody>
                    <tr>
                      <td colspan="6">Você não selecionou nenhum registro</td>
                    </tr>
                  </tbody>
                </template>
                <template v-else>

                  <tbody>
                      <template v-for="oneProductPerItem in produtos_por_items">
                        <tr>
                          <td rowspan="2" style="width: 60px; vertical-align:middle;"><b-img :src="oneProductPerItem.photo_url" style="width: 50px; min-width: 50px"/></td>
                          <td>
                            <small class="text-muted">Comprador</small><br>
                            {{ oneProductPerItem.payer_name || '&nbsp;' }}
                            <hr class="my-2"><br class="d-none d-print-block">
                            <small class="text-muted">Recebedor</small><br>
                            {{ oneProductPerItem.receiver_name || '&nbsp;' }}
                          </td>
                          <td>
                            <small class="text-muted">Pedido Plugg.to</small><br>
                            {{ oneProductPerItem.id || '&nbsp;' }}
                            <hr class="my-2"><br class="d-none d-print-block">
                            <small class="text-muted">Pedido Canal</small><br>
                            {{ oneProductPerItem.original_id || '&nbsp;' }}
                          </td>
                          <td>
                            <small class="text-muted">Canal</small><br>
                            {{ oneProductPerItem.channel || '&nbsp;'}}
                            <hr class="my-2"><br class="d-none d-print-block">
                            <small class="text-muted">Conta</small><br>
                            {{ oneProductPerItem.channel_account || '&nbsp;'}}
                          </td>
                          <td colspan="2">
                            <small class="text-muted">Nota(s) Fiscal(is)</small><br>
                            {{ oneProductPerItem.nfes || '&nbsp;' }}
                            <hr class="my-2"><br class="d-none d-print-block">

                          </td>
                        </tr>
                        <tr>
                          <td>
                            <small class="text-muted">Nome</small><br>
                            {{ oneProductPerItem.name }}
                          </td>
                          <td>
                            <small class="text-muted">sku(s)</small><br>
                            {{ skuVariation(oneProductPerItem) }}
                          </td>
                          <td>
                            <small class="text-muted">Quantidade</small><br>
                            {{ oneProductPerItem.quantity_2 }}
                          </td>
                          <td>
                            <small class="text-muted">Preço</small><br>
                            {{ formatNumber(oneProductPerItem.price) }}
                          </td>
                          <td>
                            <small class="text-muted">Total</small><br>
                            {{ formatNumber(oneProductPerItem.total) }}
                          </td>
                        </tr>
                        <tr class="d-none d-print-block">
                          <td colspan="6"></td>
                        </tr>
                        <tr class="d-none d-print-block">
                          <td colspan="6" style="border-bottom: 2px solid #000;"></td>
                        </tr>
                      </template>
                    </tbody>

                </template>

              </table>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row v-if="!produtos.length">
        <b-col>
          <div class="text-center">
            <u>Nenhum item selecionado...</u>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-button class="mt-3" variant="success" @click="moverParaEmSeparacao()" :disabled="!produtos.length">
      <i class="fas fa-money-check"></i> Mover pedidos para em separação
    </b-button>
    &nbsp;
    <b-button class="mt-3" @click="gerarPdf()" :disabled="!produtos.length">
      <i class="fas fa-money-check"></i>
      Imprimir lista de separação
    </b-button>
  </b-modal>
</template>

<script>
import barramento from "../../../../barramento";
import swal from "sweetalert2";
export default {
  data() {
    return {
      ids: [],
      produtos: [],
      produtos_por_items: [],
      fields_por_item: [
        { key: "photo_url", label: "Imagem" },
        { key: "name", label: "Nome" },
        { key: "sku", label: "SKUs" },
        { key: "quantity_2", label: "Quantidade" },
        { key: "price", label: "Preço" },
        { key: "total", label: "Total" },
      ],
      fields_por_pedido: [
        { key: "photo_url", label: "Imagem" },
        { key: "name", label: "Nome" },
        { key: "sku", label: "SKUs" },
        { key: "quantity", label: "Quantidade" },
        { key: "price", label: "Preço" },
        { key: "total", label: "Total" },
      ],
      spinner_i: false,
      selected_tipo_listagem: "por_item",
      options_tipo_listagem: [
        {
          value: "por_item",
          text: "Por item",
        },
        {
          value: "por_pedido",
          text: "Por pedido",
        },
      ],
    };
  },
  methods: {
    moverParaEmSeparacao() {
      swal({
        title: this.$t("Você tem certeza?"),
        type: "warning",
        text: this.$t(
          "Os pedidos selecionados irão para status em separação, deseja continuar?"
        ),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((ok) => {
        if (ok.value === true) {
          this.nextStatus();
        }
      });
    },
    nextStatus() {
      this.spinner_i = true;
      barramento.$emit(`expedition_splice_pendente_de_separacao`, {
        status: "warning",
        ids: this.ids,
      });
      let obj = this.produtos.map((obj) => {
        return {
          id: obj.id,
          status: "approved",
          sub_status: "processing_picking",
        };
      });
      this.$http
        .post("/api/orders/updatestatus", obj)
        .then((response) => {
          barramento.$emit(`expedition_splice_pendente_de_separacao`, {
            status: "success",
            ids: this.ids,
          });
          setTimeout(() => {
            barramento.$emit(`expedition_splice_pendente_de_separacao`, {
              status: "splice",
              ids: this.ids,
            });
          }, 2000);
          this.spinner_i = false;
          this.hideModal();
        })
        .catch((error) => {
          this.spinner_i = false;
          let errors = '';
            for (const [key, value] of Object.entries(error.response.data)) {
                errors += `<li><strong>${key}:</strong> ${value}</li>`;
            }
            swal({
              title: "Ops!",
              type: "warning",
              html: `<ul>${errors}</ul>`,
            });
        });
    },
    gerarPdf() {
      var mywindow = window.open("", "PRINT", "height=400,width=600");
      mywindow.document.write("<html><head><title>Lista de separação</title>");
      mywindow.document.write('<style type="text/css" rel="stylesheet">td {font-size: 0.8em;} .per-order-table + .per-order-table { margin-top: 10px; padding-top: 10px; border-top: 2px solid; } hr { display:none; tbody tr:nth-child(even) { padding-bottom: 15px; margin-bottom: 15px; border-bottom: 1ps solid #000;} </style>');
      mywindow.document.write("</head><body >");
      mywindow.document.write(
        document.querySelector('#table_items_pedido > .row:not([style*="display: none"]) .table-responsive').outerHTML
      );
      mywindow.document.write("</body></html>");
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      return true;
    },
    showModal() {
      this.$refs["lista_de_sepacao"].show();
    },
    hideModal() {
      this.$refs["lista_de_sepacao"].hide();
    },
    formatNumber(numero) {
      if (numero) {
        const currency = function (number) {
          return new Intl.NumberFormat("pt-br", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          }).format(number);
        };
        return currency(numero);
      }
      return numero;
    },
    skuVariation(item) {
      if (!!item.variation && !!item.variation.sku)
        return item.variation.sku;
      else
        return item.sku;
    },
  },
  beforeDestroy() {
    barramento.$off("expedition_lista_de_sepacao");
  },
  created() {
    barramento.$on("expedition_lista_de_sepacao", (produtos) => {

      this.produtos = produtos;

      var produtos_por_sku = [];

      for (var i in this.produtos) {
        this.ids.push(this.produtos[i].id);

        for (var ii in this.produtos[i].items) {
          if (!produtos_por_sku[this.produtos[i].items[ii].sku]) {
            produtos_por_sku[this.produtos[i].items[ii].sku] = {
              channel: this.produtos[i].channel,
              channel_account: this.produtos[i].channel_account,
              receiver_name: this.produtos[i].receiver_name,
              payer_name: this.produtos[i].payer_name,
              nfes: this.produtos[i].nfes,
              id: this.produtos[i].id,
              original_id: this.produtos[i].original_id,
              photo_url: this.produtos[i].items[ii].photo_url,
              name: this.produtos[i].items[ii].name,
              sku: this.produtos[i].items[ii].sku,
              quantity_2: this.produtos[i].items[ii].quantity,
              price: this.produtos[i].items[ii].price,
              total: this.produtos[i].items[ii].total,
              variation: this.produtos[i].items[ii].variation
            }
          }
          else
            produtos_por_sku[this.produtos[i].items[ii].sku].quantity_2 += this.produtos[i].items[ii].quantity;
        }
      }

      this.produtos_por_items = [];
      for (var sku in produtos_por_sku) this.produtos_por_items.push(produtos_por_sku[sku]);

      this.showModal();
    });
  },
};
</script>

<style>
.steps-form-2 {
  display: table;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 50px;
  position: relative;
}

.steps-form-2 .steps-row-2 {
  display: table-row;
}

.steps-step-2.off::after {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 434%;
  height: 2px;
  background-color: #868e96;
  margin-left: 35px;
}

.steps-form-2 .steps-row-2:before {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  height: 2px;
  background-color: #14cc4b;
  width: 1000%;
}

span.btn.btn-amber.btn-circle-2.waves-effect.inactive {
  border: 2px solid #868e96;
  background-color: white !important;
  color: #868e96;
}

.steps-form-2 .steps-row-2 .steps-step-2 {
  display: table-cell;
  text-align: center;
  position: relative;
}

.steps-form-2 .steps-row-2 .steps-step-2 p {
  margin-top: 0.5rem;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 {
  width: 70px;
  height: 70px;
  border: 2px solid #14cc4b;
  background-color: white !important;
  color: #14cc4b;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.error {
  width: 70px;
  height: 70px;
  border: 2px solid rgb(201, 9, 9) !important;
  background-color: rgb(201, 9, 9) !important;
  color: rgb(201, 9, 9) !important;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 .fa {
  font-size: 1.7rem;
}

.steps-form-2 .tag {
  display: block;
  margin-top: 15px;
}

.steps-form-2 .tag:hover {
  text-decoration: none;
}

#steps_status {
  cursor: default !important;
}

.swal2-icon.swal2-warning {
  font-size: inherit !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Support/ListaDeSepacao.vue